
export default {
  code: "eu",
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 7  // The week that contains Jan 1st is the first week of the year.
  },
  buttonText: {
    prev: "Aur",
    next: "Hur",
    today: "Gaur",
    month: "Hilabetea",
    week: "Astea",
    day: "Eguna",
    list: "Agenda"
  },
  weekLabel: "As",
  allDayHtml: "Egun<br/>osoa",
  eventLimitText: "gehiago",
  noEventsMessage: "Ez dago ekitaldirik erakusteko"
};
